<!-- 活跃员工排名 -->
<template>
  <div class="staffRank">staffRank组件测试</div>
</template>

<script>
export default {
  name: 'StaffRank',
  components: {},
  props: {},
  data() {
    return {};
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.staffRank {
}
</style>
